const FlybyLayoutForm = {
    labelCol: { span: 24 },
    wrapperCol: { span: 24 },
  };

export default FlybyLayoutForm;    